import Vue from 'vue';
import currentSubsidiaryStorage from '@/shared/current-subsidiary';

const subsidiaryModule = {
	actions: {
		async loadSubsidiaries({ commit }, { context, params }) {
			const { data: subsidiaries } = await context.$http.get('subsidiary', { params });
			commit('setSubsidiaries', [...subsidiaries]);
		},
		async loadAccountingPeriod({ commit }, { context, params }) {
			const { data: periods } = await context.$http.get('period-con', { params });
			commit('setAccountingPeriods', [...periods]);
		},
		setCurrentSubsidiary(store, currentSubsidiary) {
			const subsidiary = { ...currentSubsidiary };
			const newSubsidiary = { ...subsidiary };
			localStorage.setItem('newSubsidiary', JSON.stringify(newSubsidiary));
			if (subsidiary.id) {
				currentSubsidiaryStorage.write(subsidiary);
			} else {
				currentSubsidiaryStorage.clear();
			}
			store.commit('setCurrentSubsidiary', subsidiary);
			store.dispatch('route/UPDATE_BREAD_CRUMBS', subsidiary, { root: true });
		},
		updateSubsidiaries({ commit }, subsidiaries) {
			commit('setSubsidiaries', [...subsidiaries]);
		},
	},
	getters: {
		companyLogo(state, getters, rootState) {
			return rootState.user ? rootState.user.logo : '';
		},
		currentSubsidiary(state) {
			return state.currentSubsidiary;
		},
		getAccountingPeriod(state) {
			return state.accountingPeriod;
		},
		getSubsidiaries(state) {
			return state.subsidiaries;
		},
		getGlobalSubsidiaries(state) {
			/* const defaultSub = { id: null, name: 'Seleccione una empresa.' };
			return [].concat(defaultSub, state.subsidiaries); */
			return state.subsidiaries;
		},
	},
	mutations: {
		setCurrentSubsidiary(state, subsidiary) {
			Vue.set(state, 'currentSubsidiary', subsidiary);
		},
		setSubsidiaries(state, subsidiaries) {
			Vue.set(state, 'subsidiaries', subsidiaries);
		},
		setAccountingPeriods(state, accounting) {
			Vue.set(state, 'accountingPeriod', accounting);
		},
	},
	state: {
		accountingPeriod: [],
		currentSubsidiary: {},
		subsidiaries: [],
	},
};

export default subsidiaryModule;



// WEBPACK FOOTER //
// ./src/store/modules/subsidiary/subsidiaryModule.js